import React from "react";
import ImageVO, {ImageSize} from "../../../ts/common/ImageVO";
import ImageVOView from "./ImageVOView";

interface IProps
{
    imageVOs: ImageVO[];
    size?: ImageSize;
    captions?:boolean

}
const GalleryThumbnailView = (props: IProps) =>
{
    return <div className="thumbnail-gallery row d-flex align-items-stretch row-cols-2 row-cols-md-3 gx-2 gy-2 mt-2">

        {props.imageVOs.map((imageVO, index) =>
        {

            return <div
                className="col"
                key={index}
            >
                <ImageVOView
                    imageVO={imageVO}
                    size={props.size ?? "small_square"}
                    caption={props.captions ? imageVO.alt : undefined}
                />
            </div>;
        })}
    </div>
}
export default GalleryThumbnailView;